import { HsShaderDataType } from '../enums/shader-data-type.enum';
import { HsShaderObjectType } from '../enums/shader-object-type.enum';

/**
 * Handles s add vertex uniform.
 */
export function hsAddVertexUniform(name: string, dataType: HsShaderDataType, objectType: HsShaderObjectType): string {
  if (objectType === HsShaderObjectType.single) {
    return `uniform ${HsShaderDataType[dataType]} u_${name};`;
  }
  if (objectType === HsShaderObjectType.collection) {
    if (dataType === HsShaderDataType.mat2) {
      return `in vec2 a_${name}0;
      in vec2 a_${name}1;`;
    }
    if (dataType === HsShaderDataType.mat3) {
      return `in vec3 a_${name}0;
      in vec3 a_${name}1;
      in vec3 a_${name}2;`;
    }
    if (dataType === HsShaderDataType.mat4) {
      return `in vec4 a_${name}0;
      in vec4 a_${name}1;
      in vec4 a_${name}2;
      in vec4 a_${name}3;`;
    }
    return `in ${HsShaderDataType[dataType]} a_${name};`;
  }
  return '';
}
